import { render, staticRenderFns } from "./InsuredQuery.vue?vue&type=template&id=cf1d40dc&scoped=true&"
import script from "./InsuredQuery.vue?vue&type=script&lang=js&"
export * from "./InsuredQuery.vue?vue&type=script&lang=js&"
import style0 from "./InsuredQuery.vue?vue&type=style&index=0&id=cf1d40dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d40dc",
  null
  
)

export default component.exports